export const side1 = [
  {
    title: 'Fitur',
    url: '#fitur',
  },
  {
    title: 'Manfaat',
    url: '#manfaat',
  },
  {
    title: 'Cara Kerja',
    url: '#carakerja',
  },
];

export const side2 = [
  {
    title: 'Tim',
    url: '/ngamenhub-web/#tim',
  },
  {
    title: 'Ngamen Bizz',
    url: '/ngamenbizz/',
    link: true,
  },
];
